// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eMkb","comment":"styles_comment__3OlRf"};